exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".inputLabel{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", "", {"version":3,"sources":["/home/circleci/repo/app/components/commons/formParts/inputLabel.vue"],"names":[],"mappings":"AAyBA,YACE,oBAAA,oBAAA,aACA,yBAAA,sBAAA,kBAAA,CAAA","file":"inputLabel.vue?vue&type=style&index=0&lang=sass&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.inputLabel\n  display: flex\n  align-items: center\n"],"sourceRoot":""}]);

// exports
